import http from "./httpService";
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/aircrafts";

function aircraftUrl(uri) {
  return `${apiEndpoint}/${uri}`;
}

export function getById(aircraft_id) {
  const url = aircraftUrl(aircraft_id);

  return http.get(url);
}

export function getAircraftYears() {
  const url = aircraftUrl("years");

  return http.get(url);
}

export function getAircraftByManufacturer(manufacturer_id) {
  const url = aircraftUrl(`manufacturer/${manufacturer_id}`);

  return http.get(url);
}

export function getCountriesOfManufacturer() {
  const url = aircraftUrl("countries");

  return http.get(url);
}

export function saveAircraft(aircraft) {
  if (aircraft.aircraft_id) {
    const body = { ...aircraft };
    delete body.aircraft_id;

    return http.put(aircraftUrl(aircraft.aircraft_id), body);
  }

  return http.post(apiEndpoint, aircraft);
}

export function deleteAircraft(aircraft_id) {
  return http.delete(aircraftUrl(aircraft_id));
}
